import { Stack, Typography } from '@mui/material';
import PatientHPOLists from './PatientHPOLists';

const PatientHPO = () => (
  <Stack direction="column" spacing={2}>
    <Typography variant="subtitle1">Phenotype terms</Typography>
    <PatientHPOLists />
  </Stack>
);

export default PatientHPO;
